import { render, staticRenderFns } from "./KurdishContractDiplomatiSafiran.vue?vue&type=template&id=6e0df288&scoped=true&"
import script from "./KurdishContractDiplomatiSafiran.vue?vue&type=script&lang=js&"
export * from "./KurdishContractDiplomatiSafiran.vue?vue&type=script&lang=js&"
import style0 from "./KurdishContractDiplomatiSafiran.vue?vue&type=style&index=0&id=6e0df288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0df288",
  null
  
)

export default component.exports